var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bodyLoader d-flex flex-column"},[_c('img',{attrs:{"src":"/img/brand/logo_new_loading.svg","alt":"logo-conectados"}}),_vm._v(" "),_c('div',{staticClass:"progress-loading mt-3"})])
}]

export { render, staticRenderFns }